<section class="absences-dialog" role="dialog" aria-labelledby="absences-dialog-title">
  <header class="absences-dialog__header">
    <div class="absences-dialog__heading">
      <span class="absences-dialog__eyebrow">
        @if (badgeLabel()) {
          {{ badgeLabel() }}
        } @else {
          {{ 'tour_widget.upcoming_absences_badge' | translate }}
        }
      </span>
      <h2 id="absences-dialog-title" class="absences-dialog__title">{{ serviceName() }}</h2>
    </div>
    <button
      type="button"
      class="absences-dialog__close"
      [attr.aria-label]="'tour_widget.upcoming_absences_dialog_close' | translate"
      (click)="close()"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <ol class="absences-dialog__list">
    @for (absence of absences(); let i = $index; track absence.uuid) {
      <li class="absences-row" [style.--row-index]="i">
        <span class="absences-row__icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" stroke-width="1.4" />
            <path d="M2 6.5h12M5.5 1.5v3M10.5 1.5v3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
          </svg>
        </span>
        <div class="absences-row__body">
          <time class="absences-row__date" [attr.datetime]="absence.from_date_utc ?? absence.from_date">
            @if (isSameDay(absence)) {
              {{ (absence.from_date_utc ?? absence.from_date) | date: 'MMM d, y' : userTimezone : lang() }}
              @if (!isEffectivelyAllDay(absence)) {
                <span class="absences-row__time">·
                  {{ (absence.from_date_utc ?? absence.from_date) | date: timeFormat : userTimezone }}
                  – {{ (absence.to_date_utc ?? absence.to_date) | date: timeFormat : userTimezone }}
                </span>
              }
            } @else if (isEffectivelyAllDay(absence)) {
              {{ (absence.from_date_utc ?? absence.from_date) | date: 'MMM d' : userTimezone : lang() }}
              <span class="absences-row__date-sep" aria-hidden="true">→</span>
              {{ (absence.to_date_utc ?? absence.to_date) | date: 'MMM d, y' : userTimezone : lang() }}
            } @else {
              {{ (absence.from_date_utc ?? absence.from_date) | date: 'MMM d' : userTimezone : lang() }},
              {{ (absence.from_date_utc ?? absence.from_date) | date: timeFormat : userTimezone }}
              <span class="absences-row__date-sep" aria-hidden="true">→</span>
              {{ (absence.to_date_utc ?? absence.to_date) | date: 'MMM d, y' : userTimezone : lang() }},
              {{ (absence.to_date_utc ?? absence.to_date) | date: timeFormat : userTimezone }}
            }
          </time>
          @if (absence.title) {
            <div class="absences-row__title">{{ absence.title }}</div>
          }
        </div>
        @if (isEffectivelyAllDay(absence)) {
          <span class="absences-row__pill">{{ 'tour_widget.upcoming_absences_all_day' | translate }}</span>
        }
      </li>
    }
  </ol>
</section>
